import styled from '@emotion/styled';
import MuiButton from '@material-ui/core/Button';
import { ListItemSecondaryText } from '$components/List';

import COLORS from '$variables/colors';
import { typography, transition, spacing } from '$variables/theme';

export const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => !['iconOnly'].includes(prop),
})`
  color: ${COLORS.black};
  font-size: 14px;
  font-weight: ${typography.fontWeightMedium};
  line-height: 14px;
  background-color: ${COLORS.white};
  height: 30px;

  display: inline-flex;

  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  align-items: center;
  text-transform: none;
  min-width: 0;
  padding: ${({ iconOnly }) => (iconOnly ? '5px' : '5px 10px')};
  border: 1px solid ${COLORS.border1};

  & svg {
    font-size: 18px !important;
    color: ${COLORS.black};
    transition: ${transition.color};
  }

  .MuiButton-startIcon {
    margin-left: 0;
    margin-right: 6px;
  }

  :hover {
    & svg {
      color: ${({ iconOnly }) => (iconOnly ? COLORS.black : COLORS.green)};
    }
  }

  :disabled {
    & svg {
      color: ${COLORS.disabled};
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  cursor: default;
`;

export const ExportSecondaryText = styled(ListItemSecondaryText)`
  margin-top: ${spacing.xSmall};
`;
